import { FC, memo } from 'react';
import { Box, Typography } from '@mui/material';
import type { TimelineDay } from '../types';
import HeatmapDayColumn from './HeatmapDayColumn';

interface HeatmapTimelineProps {
  days: TimelineDay[];
}

const HeatmapTimeline: FC<HeatmapTimelineProps> = ({ days }) => (
  <Box display="flex" gap="1px">
    {days.map(day => (
      <HeatmapDayColumn key={day.date} fullBorder>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={0.5}
          height="100%"
          bgcolor="background.default"
        >
          <Typography variant="caption" color="textSecondary" lineHeight={1}>
            {day.day}
          </Typography>

          <Typography variant="caption" color="textSecondary" lineHeight={1}>
            {day.monthLabel}
          </Typography>
        </Box>
      </HeatmapDayColumn>
    ))}
  </Box>
);

export default memo(HeatmapTimeline);
